import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity7 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_7;
}

export default GravelRoadTileEntity7;
